var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2157 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2157 144)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(8.625 12.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.792 3.938c.264 0 .479.195.479.437s-.215.438-.48.438c-.264 0-.479-.196-.479-.438s.215-.438.48-.438M23.958 12.688c.265 0 .48.195.48.437s-.215.438-.48.438c-.264 0-.479-.196-.479-.438s.215-.438.48-.438"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.75,
    height: 17.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.26 7.401c.562.674 1.448 1.055 2.375 1.021 1.455 0 2.636-.808 2.636-1.805 0-.996-1.18-1.803-2.636-1.803C1.179 4.814 0 4.005 0 3.008c0-.998 1.18-1.805 2.635-1.805.926-.034 1.813.347 2.374 1.02M2.635 8.422L2.635 9.625M2.635 0L2.635 1.203",
    transform: "translate(11.5 4.375)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.ad943449174d1d1fef24673c29003949.svg";
export { ForwardRef as ReactComponent };